<template>
    <div>
        {{content}}
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data() {
        return {
            content:null,
            load:true
        }
    },
    created() {
        axios.get("http://api-metrika.yandex.ru/stat/traffic/summary.json?id=51844001&pretty=1&date1=$today&date2=$today", { headers: {
                'Content-type': 'application/x-yametrika+json',
                'Authorization': 'OAuth AQAAAAAKfb8rAAVs_j8EZKJTD0t2lA9fol4ifQc'
              }}).then(response => console.log(response))
              .finally(() => (this.load = false));
    }
}
</script>

<style lang="less" scoped>

</style>
